export default {
  SUBMIT_FOR_APPROVAL: 'SUBMIT_FOR_APPROVAL', // user didnt create a page yet
  WAIT_FOR_FEEDBACK: 'WAIT_FOR_FEEDBACK', // user created the page and waiting for owner move
  APPROVED: 'APPROVED', // page is approved by owner
  REJECTED: 'REJECTED', // page is rejected by owner
  NEW_FEEDBACK: 'NEW_FEEDBACK', // feeback provided
};
